import { render, staticRenderFns } from "./CheckDataFromFileModal.vue?vue&type=template&id=48312221&"
import script from "./CheckDataFromFileModal.vue?vue&type=script&lang=js&"
export * from "./CheckDataFromFileModal.vue?vue&type=script&lang=js&"
import style0 from "./CheckDataFromFileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports